import React, { useState } from "react";
import { Button, Modal, Input, Select, Tabs, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import organizationsActions from "../../../redux/organizations/actions";
import "./index.css";

const AdminOrganizationCreateModal = () => {
  const dispatch = useDispatch();
  const { addOrganization, checkOrganizationConnectionRequest } =
    organizationsActions;
  const { cities } = useSelector((state) => state.organizationsReducer);
  const [openCreateOrganizationModal, setOpenCreateOrganizationModal] =
    useState(false);
  const [name, setName] = useState("");
  const [displayNameBulgarian, setDisplayNameBulgarian] = useState("");
  const [displayNameEnglish, setDisplayNameEnglish] = useState("");
  const [note, setNote] = useState("");
  const [city, setCity] = useState("");
  const [touchSaleDatabaseSource, setTouchSaleDatabaseSource] = useState("");
  const [touchSaleDatabasePort, setTouchSaleDatabasePort] = useState("");
  const [touchSaleDatabase, setTouchSaleDatabase] = useState("");
  const [touchSaleDatabaseUserName, setTouchSaleDatabaseUserName] =
    useState("");
  const [touchSaleDatabasePassword, setTouchSaleDatabasePassword] =
    useState("");
  const [checkRequiredInput, setCheckRequiredInput] = useState(false);
  const [nonNumberPortErrorMessage, setNonNumberPortErrorMessage] =
    useState("");
  const [minNameLengthErrorMessage, setMinNameLengthErrorMessage] =
    useState("");
  const [
    minDisplayBGNameLengthErrorMessage,
    setMinDisplayBGNameLengthErrorMessage,
  ] = useState("");

  const citiesArrayForSelect = cities.map((city) => {
    return {
      value: city,
      label: city,
    };
  });

  const resetInputs = () => {
    setName("");
    setDisplayNameBulgarian("");
    setDisplayNameEnglish("");
    setNote("");
    setCity("");
    setTouchSaleDatabaseSource("");
    setTouchSaleDatabasePort("");
    setTouchSaleDatabase("");
    setTouchSaleDatabaseUserName("");
    setTouchSaleDatabasePassword("");
    setNonNumberPortErrorMessage("");
    setMinNameLengthErrorMessage("");
    setMinDisplayBGNameLengthErrorMessage("");
  };

  const openCreateModal = () => {
    setOpenCreateOrganizationModal(true);
  };

  const closeCreaetModal = () => {
    setOpenCreateOrganizationModal(false);
    setCheckRequiredInput(false);
    resetInputs();
  };

  const citySelectSearch = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const createOrganization = () => {
    if (
      name.length >= 2 &&
      displayNameBulgarian.length >= 2 &&
      touchSaleDatabaseSource.length > 0 &&
      touchSaleDatabasePort.length > 0 &&
      touchSaleDatabase.length > 0 &&
      touchSaleDatabaseUserName.length > 0 &&
      touchSaleDatabasePassword.length > 0
    ) {
      setCheckRequiredInput(false);
      setOpenCreateOrganizationModal(false);
      dispatch(
        addOrganization({
          name,
          displayNameBulgarian,
          displayNameEnglish,
          note,
          city,
          touchSaleDatabaseSource,
          touchSaleDatabasePort,
          touchSaleDatabase,
          touchSaleDatabaseUserName,
          touchSaleDatabasePassword,
        })
      );
      resetInputs();
    } else {
      setCheckRequiredInput(true);
      notification["warning"]({
        message: "Моля, попълнете празните полета",
      });
    }
  };
  const onCheckConnectionRequest = () => {
    dispatch(
      checkOrganizationConnectionRequest({
        Database: touchSaleDatabase,
        DatabasePassword: touchSaleDatabasePassword,
        DatabasePort: touchSaleDatabasePort,
        DatabaseSource: touchSaleDatabaseSource,
        DatabaseUserName: touchSaleDatabaseUserName,
      })
    );
  };

  const filterNonNumericPort = (e) => {
    const input = e.target.value.replace(/[^0-9]/g, "");
    if (input !== e.target.value) {
      setNonNumberPortErrorMessage("приема само цифри");
    } else {
      setNonNumberPortErrorMessage("");
    }
    setTouchSaleDatabasePort(input);
  };

  const minInputLength = (e, setter, errorSetter) => {
    const input = e.target.value;
    if (input.length < 2) {
      errorSetter("минимум 2 символа");
    } else {
      errorSetter("");
    }
    setter(input);
  };

  const tabsItems = [
    {
      key: "1",
      label: "General",
      children: (
        <>
          <div className="admin-organization-create-sections">
            <div className="admin-organization-input-container">
              <label className="admin-organization-create-input-label">
                Портал име{" "}
                <span className="admin-organization-create-required-span">
                  *
                </span>
                {minNameLengthErrorMessage && (
                  <span className="admin-organization-create-error">
                    {minNameLengthErrorMessage}
                  </span>
                )}
              </label>
              <Input
                value={name}
                className={
                  name.length < 2 &&
                  checkRequiredInput &&
                  "admin-organization-create-required-input"
                }
                onChange={(e) =>
                  minInputLength(e, setName, setMinNameLengthErrorMessage)
                }
              />
            </div>
            <div className="admin-organization-input-container">
              <label className="admin-organization-create-input-label">
                Име (Български){" "}
                <span className="admin-organization-create-required-span">
                  *
                </span>
              </label>
              {minDisplayBGNameLengthErrorMessage && (
                <span className="admin-organization-create-error">
                  {minDisplayBGNameLengthErrorMessage}
                </span>
              )}
              <Input
                value={displayNameBulgarian}
                className={
                  displayNameBulgarian.length < 2 &&
                  checkRequiredInput &&
                  "admin-organization-create-required-input"
                }
                onChange={(e) =>
                  minInputLength(
                    e,
                    setDisplayNameBulgarian,
                    setMinDisplayBGNameLengthErrorMessage
                  )
                }
              />
            </div>
            <div className="admin-organization-input-container">
              <label className="admin-organization-create-input-label">
                Име (Английски)
              </label>
              <Input
                value={displayNameEnglish}
                onChange={(e) => setDisplayNameEnglish(e.target.value)}
              />
            </div>
          </div>

          <div className="admin-organization-create-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-create-input-label">
                Описание
              </label>
              <Input value={note} onChange={(e) => setNote(e.target.value)} />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-create-input-label">
                Град{" "}
                <span className="admin-organization-create-required-span">
                  *
                </span>
              </label>
              <Select
                showSearch
                filterOption={citySelectSearch}
                status={city.length === 0 && checkRequiredInput && "error"}
                className="admin-organization-full-width"
                options={citiesArrayForSelect}
                onChange={(value) => setCity(value)}
                value={city}
              />
            </div>
          </div>

          <div className="admin-organization-create-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-create-input-label">
                IP{" "}
                <span className="admin-organization-create-required-span">
                  *
                </span>
              </label>
              <Input
                value={touchSaleDatabaseSource}
                className={`${
                  touchSaleDatabaseSource.length === 0 &&
                  checkRequiredInput &&
                  "admin-organization-create-required-input"
                } admin-organization-full-width`}
                onChange={(e) => setTouchSaleDatabaseSource(e.target.value)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-create-input-label">
                Port{" "}
                <span className="admin-organization-create-required-span">
                  *
                </span>
                {nonNumberPortErrorMessage && (
                  <span className="admin-organization-create-error">
                    {nonNumberPortErrorMessage}
                  </span>
                )}
              </label>
              <Input
                value={touchSaleDatabasePort}
                className={`${
                  touchSaleDatabasePort.length === 0 &&
                  checkRequiredInput &&
                  "admin-organization-create-required-input"
                } admin-organization-full-width`}
                onChange={(e) => filterNonNumericPort(e)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-create-input-label">
                Database{" "}
                <span className="admin-organization-create-required-span">
                  *
                </span>
              </label>
              <Input
                value={touchSaleDatabase}
                className={`${
                  touchSaleDatabase.length === 0 &&
                  checkRequiredInput &&
                  "admin-organization-create-required-input"
                } admin-organization-full-width`}
                onChange={(e) => setTouchSaleDatabase(e.target.value)}
              />
            </div>
          </div>

          <div className="admin-organization-create-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-create-input-label">
                Потребител{" "}
                <span className="admin-organization-create-required-span">
                  *
                </span>
              </label>
              <Input
                value={touchSaleDatabaseUserName}
                className={`${
                  touchSaleDatabaseUserName.length === 0 &&
                  checkRequiredInput &&
                  "admin-organization-create-required-input"
                } admin-organization-full-width`}
                onChange={(e) => setTouchSaleDatabaseUserName(e.target.value)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-create-input-label">
                Парола{" "}
                <span className="admin-organization-create-required-span">
                  *
                </span>
              </label>
              <Input
                value={touchSaleDatabasePassword}
                className={`${
                  touchSaleDatabasePassword.length === 0 &&
                  checkRequiredInput &&
                  "admin-organization-create-required-input"
                } admin-organization-full-width`}
                onChange={(e) => setTouchSaleDatabasePassword(e.target.value)}
              />
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      <Button
        className="admin-organization-create-button"
        type="primary"
        onClick={openCreateModal}
      >
        Създай организация
      </Button>
      <Modal
        title="Създай организация"
        width={window.innerWidth > 760 ? "50%" : "95%"}
        open={openCreateOrganizationModal}
        onCancel={closeCreaetModal}
        footer={[
          <Button key="1" onClick={onCheckConnectionRequest}>
            Провери връзката
          </Button>,
          <Button key="2" onClick={closeCreaetModal}>
            Затвори
          </Button>,
          <Button key="3" type="primary" onClick={createOrganization}>
            Запази
          </Button>,
        ]}
      >
        <Tabs
          className="admin-organization-create"
          type="card"
          defaultActiveKey="1"
          items={tabsItems}
        />
      </Modal>
    </>
  );
};
export default AdminOrganizationCreateModal;
